export default "__VITE_ASSET__B7pUte$___"